export enum MetalsProductVersionStatus {
	Draft = 'Draft',
	Released = 'Released',
	Obsolete = 'Obsolete',
}